<template>
  <div class="vx-col w-full mb-base m-auto" id="parentx-demo-1">
   

    <vx-card title="Vehicle Timesheet">
      <div class=" " style=" margin-top: -52px !important;float: right;" >
        <form autocomplete='off'>
          <div class="datepicker-main">
            <div class="datewrapper">  
              <label for="" class="float-right">Select Office</label>
              <vs-select
                autocomplete
                class="text-right"
                v-validate="''"
                name="office_id"
                v-model="officeID"
                @change="changeOffice()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.office_name"
                  v-for="(item,index) in allOffices"
                />
              </vs-select>
            </div> 
          </div>
          <!-- <label class="float-left">Office :- </label> -->
         
        </form>
        <!-- <span class="text-danger text-sm">{{ errors.first('office_id') }}</span> -->
      </div>
      <vs-tabs alignment="center" class="set_min_height">
        <vs-tab label="Day">
          
          <div class="mt-5 mb-5">
            <vs-table :data="DailyTimeSheet" pagination :max-items="perPage1" search >
              <template slot="header" >
                <!-- <h3 class="mb-5 float-right">
                  Users Daily Time Log
                </h3> -->
                
                <div class="datepicker-main">
                  <div class="datewrapper">  
                    <label for="" class="float-right">Select Date</label>
                    <datepicker placeholder="Select Date" class="float-right" format="dd/MM/yyyy" v-model="currentDate" @on-change="getDailyTimeSheet()" :disabledDates="disabledDates" ></datepicker>
                    
                  </div> 
                </div>

              </template>
              <template slot="thead">
                <vs-th style="width: 20%;"> User </vs-th>
                <vs-th class="" style="width: 65%;">
                  Time Bar
                </vs-th>
                <vs-th style="width: 15%;">Total Time</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td>
                      <div class="relative inline-flex float-left">
                          <img class="size" :src="require(`@/assets/images/pages/car.png`)" />
                          <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"  
                          :class="'bg-success'" ></div>
                      </div>
                      <h6 class="mt-2 ml-16"> {{ tr.vehical_details.number }}</h6>
                  </vs-td>
                  <vs-td >
                    <div class="progress" @click="openSlidebar(tr.users_in_out.user_id,currentDate)">
                      <!-- <div class="progress-bar" role="progressbar" 
                         v-for="times in calculatePercetage(tr.users_data,timezone)" 
                         v-bind:style="{ background: times.color , width: times.per  + '%' }"
                         >
                      </div> -->
                      <div class="progress-bar" role="progressbar" 
                         v-for="times in tr.inoutData" 
                         v-bind:style="{ background: times.color , width: times.percentage  + '%' }"
                         >
                      </div>
                    </div>
                  </vs-td>
                 <vs-td>{{  convertToTime(tr.totalActiveMinutes) }}</vs-td>
                 <!-- <vs-td>{{  tr.totalActiveMinutes | moment("h:mm:ss ") }}</vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <!-- <div style="height:50px;">
            <div class="float-left">
              <vs-select label="Record Per Page" v-model="perPage1" autocomplete>
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in recordList"
                />
              </vs-select>
            </div>
          </div> -->
        </vs-tab>
        <vs-tab label="Week">
          
          <div class="mt-5 mb-5">
            <vs-table :data="WeeklyTimeSheet" pagination :max-items="perPage1" search>
              <template slot="header" >
                <!-- <h3 class="mb-5 float-right">
                  Weekly Time Log
                </h3> -->
                <div class="datepicker-main">
                  <div class="datewrapper">  
                    <label for="" class="float-right">Select Week Date</label>
                    <datepicker placeholder="Select Date" class="float-right" format="dd/MM/yyyy" v-model="date"  @change="dateweek()" :disabledDates="disabledDates"></datepicker>
                  </div> 
                </div>
                <!-- <label for="" class="float-right">Select Week Date</label> -->
               

              </template>
              <template slot="thead">
                <vs-th> User </vs-th>
                <vs-th v-for="dates in WeekDates" class="">
                  {{ dates.Day }} </br> {{ dates.Date }} 
                </vs-th>
                <vs-th>Total Time</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                     <div class="relative inline-flex float-left">
                          <img class="size" :src="require(`@/assets/images/pages/car.png`)" />
                          <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"  
                          :class="'bg-success'" ></div>
                      </div>
                      <h6 class="mt-2 ml-16"> {{ tr.vehical_details.number }}</h6>
                  </vs-td>
                  <vs-td v-for="times in tr.dateWiseData">
                    <div class="time-box" @click="openSlidebar(tr.user_id,times.date)" >
                      <span>{{convertToTime(times.activeMinutes)}}</span>
                    </div>
                  </vs-td>
                 <vs-td>{{ convertToTime(tr.totalActiveMinutes) }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <!-- <div style="height:50px;">
            <div class="float-left">
              <vs-select label="Record Per Page" v-model="perPage1" autocomplete>
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in recordList"
                />
              </vs-select>
            </div>
          </div> -->
        </vs-tab>
        <vs-tab label="Month">
          <div class="mt-5 mb-5">
          <div>
           
          </div>
            <vs-table :data="MonthlyTimeSheet" pagination :max-items="perPage1" search>
              <template slot="header" >
                <!-- <h3 class="mb-5">
                  Users Monthly Time Log
                </h3> -->
                <div class="datepicker-main">
                  <div class="datewrapper">  
                    <label for="" class="float-right">Select Month</label>
                    <datepicker placeholder="Select Date" class="float-right" format="MMMM" :minimumView="'month'" :maximumView="'month'" v-model="currentMonth" :disabledDates="disabledDates"></datepicker>
                  </div> 
                </div>
                
            <!-- <label for="" class="vs-input--label float-right">Select Month</label> -->
              </template>
              <template slot="thead">
                <vs-th> User </vs-th>
                <vs-th v-for="dates in MonthDates" class=""> {{ dates.Date }} </vs-th>
                <vs-th>Total Time</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td>
                    
                     <div class="relative inline-flex float-left">
                          <img class="size" :src="require(`@/assets/images/pages/car.png`)" />
                          <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"  
                          :class="'bg-success'" ></div>
                      </div>
                      <h6 class="mt-2 ml-16"> {{ tr.vehical_details.number }}</h6>
                  </vs-td>
                  <vs-td v-for="times in tr.dateWiseData">
                    <div class="time-box" @click="openSlidebar(tr.user_id,times.date)" >
                      <span>{{convertToTime(times.activeMinutes)}}</span>
                    </div>
                  </vs-td>
                  <vs-td>{{ convertToTime(tr.totalActiveMinutes) }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <!-- <div style="height:50px;">
            <div class="float-left">
              <vs-select label="Record Per Page" v-model="perPage" autocomplete>
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in recordList"
                />
              </vs-select>
            </div>
          </div> -->
        </vs-tab>
      </vs-tabs>
     
    </vx-card>
   

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';

export default {
  components: {
    Datepicker,
    flatPickr
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      deleteIndex: 0,
      addTimesheet: false,
      editTimesheet: false,
      deleteTimesheet: false,
      editTime: null,
      editTimeID: null,
      inTime : null,
      outTime : null,
      officeID : '5d8063d8b2e9fb1d7e4c9f42',
      allOffices : [],
      addStatus: null,
      addTime:null,
      comment:null,
      InOutStatus: [
        {value: "IN",name: "In"},
        {value: "OUT",name: "Out"},
        {value: "CIN",name: "Clock In"},
        {value: "COUT",name: "Clock Out"},
        {value: "BI",name: "Break"}],
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: false
      },
      disabledDates: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1), // Disable all dates after specific date
      },
      
      active: false,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      perPage1: 25,
      totalPage1: 1,
      currentPage1: 1,
      status: 'A',
      switch1: true,
      MonthlyTimeSheet: [],
      WeeklyTimeSheet: [],
      DailyTimeSheet: [],
      MonthDates: [],
      WeekDates: [],
      userID: null,
      addTimeDate: null,
      editTimeDate:null,
      currentDate: new Date(),
      currentMonth: new Date(),
      date: new Date(),
      recordList: [
        {
          text: 25,
          value: 25
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 100,
          value: 100
        },
        {
          text: 250,
          value: 250
        }
      ],
      search : null,
      format: "dd/MM/yyyy",
      sidebarUserData : null,
      currentTime: null,
    };
  },
  mounted:function() {
    this.getOffice();
    setTimeout(() => {
      
      this.liveInOutStatus();
      // this.getMonthlyDate();
      // this.getMonthlyTimeSheet();
      // this.dateweek();
      // this.getDailyTimeSheet();
    }, 200);
  },
  watch: {
    currentPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    currentPage1(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage1(nv) {
      if (nv) {
        this.getItems();
      }
    },
    date(nv) {
      if (nv) {
        console.log('w')
        this.dateweek();
      }
    },
    currentMonth(nv) {
      if (nv) {
        console.log('m')
       this.getMonthlyDate();
        this.getMonthlyTimeSheet();
      }
    },
    currentDate(nv) {
      if (nv) {
        console.log('d')
        this.getDailyTimeSheet();
      }
    },
    search(nv) {
      if(!nv) {
        this.perPage = 25
        this.currentPage = 1
        if(this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1
        }
        this.getItems()
      }
    }
  },
  methods: {
    changeOffice(){
      this.getMonthlyDate();
      this.getMonthlyTimeSheet();
      this.dateweek();
      this.getDailyTimeSheet();
    },
    getOffice() {
      this.$vs.loading({ color: "primary" });
      
      let url = 'office/getAll';
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.allOffices = data;
          this.officeID = data[0].id;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getTime(){
      var d = new Date();
      var date = d.getTime();
      this.currentTime = moment.tz(date).startOf('date').valueof();

    },    
    dateweek(){
      let date = this.date;
      let result = [];
      for (let i = 1; i <= 7; i++) {
        let s =  moment(date).isoWeekday(i);
        result.push({ 
                      "Date": moment(s).format('MMM DD'), 
                      "Day": moment(s).format('dddd')
                    });
      }
      this.WeekDates = result;
      this.getWeeklyTimeSheet();
    },
   
    getMonthlyDate(){
      let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let d = new Date();
      let year = d.getFullYear(); 
      let month = moment(this.currentMonth).format('MM') - 1;
      let names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      let date = new Date(year, month, 1);
      let DayAndDate = [];
      let result = [];
      while (date.getMonth() == month) {
        //
         let dd = date.getDate()+' '+monthNames[date.getMonth()];
          result.push({ "Date": dd, "Day": names[date.getDay()] });
          date = new Date(year, month, date.getDate() + 1);
          // DayAndDate.setDate(date.getDate() + 1);
      }
      this.MonthDates = result;
      //  console.log('date',result);
        
    },
    convertToTime(totalMinutes) {
        let hours = Math.floor(totalMinutes / 60);          
        let minutes = totalMinutes % 60;
        
        return hours+':'+minutes;

    },
    getDailyTimeSheet() {
     
      this.$vs.loading({ color: "primary" });
      
      let date  =  moment.tz(this.currentDate, this.timezone).format('DD/MM/YYYY');

      // let url = "inout/getDailyTimeSheet";
      let url = "getVehicalDailyProgressBar";
      
      url += "?date="+ date;
      url += "&office_id="+ this.officeID;
     
      
      
      this.axios
        .post(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          //  console.log('daily data',data);
          if (data.length != 0) {
            
            this.DailyTimeSheet = data;
          }
          else{
            this.DailyTimeSheet = [];
          }
           
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getWeeklyTimeSheet() {
       
      this.$vs.loading({ color: "primary" });

      let date  =  moment.tz(this.date, this.timezone).format('DD/MM/YYYY');

      let url = "getVehicalWeeklyTimeSheet";
      url += "?fromDate="+ date;
      url += "&office_id="+ this.officeID;
       
      this.axios
        .post(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          console.log('weekly',data);
          this.WeeklyTimeSheet = data;

          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getMonthlyTimeSheet() {
     
      this.$vs.loading({ color: "primary" });
    
      let month = moment.tz(this.currentMonth, this.timezone).format('MM');
      let url = "getVehicalMonthlyTimeSheet";
      url += "?month="+ month;
      url += "&office_id="+ this.officeID;
     
     
      this.axios
        .post(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          console.log('monthly',data);
          this.MonthlyTimeSheet = data;

          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch(e => {
          this.showError(e);
        });
    },
  }
};
</script>

<style>
.application-action {
  float: left !important;
}
.time-box {
    background-color: lightgrey;
    width: 100px;
    border: 1px black;
    padding: 5px;
    margin: 2px;
    text-align: center;
    float: left;
}
.vs-table--tbody {
      z-index: 1 !important;
}
.vdp-datepicker {
    z-index: 2;
}
.vdp-datepicker__calendar{    right: 0;}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.datepicker-main { display: flex; justify-content: center; align-items: center; width: 100%; }

.datewrapper {display: flex;}

.datewrapper label { float: right; text-align: right; line-height: 40px; padding-right: 10px; font-size: 14px !important; font-weight:bold; }

.sidesheet .vs-sidebar {   max-width: 420px !important; z-index: 99999 !important;}

</style>


<style lang="scss">
.sidesheet .vs-sidebar--background {
    z-index: 99999 !important;
}
.sidesheet .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.sidesheet .footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.delete-timesheet {
  margin: 16px 0px;
  padding: 0px 20px;
}

.sidesheet .vs-sidebar--items{
    height: 756px;
   overflow-y: scroll;
}
.size { width: 40px;}
</style>